import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';

interface ActivityReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    filter: {
        dZoneGroups: any;
        targetDates: Date[];
    };

    activity: any[];
}

const state: ActivityReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        dZoneGroups: null,
        targetDates: [new Date(), new Date()],
    },

    activity: [],
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).add(1, 'day').format('YYYY-MM-DD')
    }

    if (params.dZoneGroups) {
        queryParams.delivery_zone_id = params.dZoneGroups;
    }
    if (params.employeeId) {
        queryParams.employee_id = params.employeeId;
    }
    if (params.targetName) {
        queryParams.target_name = params.targetName;
    }
    if (params.targetId) {
        queryParams.target_id = params.targetId;
    }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<ActivityReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.activity')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    const content = result.getOperation(REPORT_DATA).getContent()
                    const fields = content.activity.documents.map(
                        (item: any) => {
                            const raw: any[] = []
                            Object.keys(item.raw).forEach((key: any) => {
                                const val = item.raw[key]
                                try {
                                    if (val.new && (val.new.startsWith('s:') || val.new.startsWith('d:'))) {
                                        raw.push(val.new)
                                    }
                                    if (val.old && (val.old.startsWith('s:') || val.old.startsWith('d:'))) {
                                        raw.push(val.old)
                                    }
                                } catch (e) {
                                    console.log(e)
                                }
                            })
                            return raw
                        }).flat(2).filter((value: any, index: any, self: any) => {
                            return self ? self.indexOf(value) === index : false;
                        })
                    const requsts = fields.map((item: string) => {
                        return vm.$q(item)
                            .raw('documents.get')
                            .action({
                                id: item
                            })
                    })
                    vm.$db(requsts).then((reqResult: ServerResult) => {
                        const byName = reqResult.getOperationNames()
                        content.activity.documents = content.activity.documents.map(
                            (item: any) => {
                                Object.keys(item.raw).forEach((key: any) => {
                                    const val = item.raw[key];
                                    val.new = byName.includes(val.new) ? reqResult.getOperation(val.new).getContent().document : val.new;
                                    val.old = byName.includes(val.old) ? reqResult.getOperation(val.old).getContent().document : val.old;
                                })
                            return item
                        })
                        commit('SET_REPORT_DATA', content);
                        commit('LOADED_SUCCESS');

                        resolve();
                    }).catch((reqResult: ServerResult) => {
                        const byName = reqResult.getOperationNames()
                        content.activity.documents = content.activity.documents.map(
                            (item: any) => {
                                Object.keys(item.raw).forEach((key: any) => {
                                    const val = item.raw[key];
                                    val.new = byName.includes(val.new) && reqResult.getOperation(val.new).getContent() ? reqResult.getOperation(val.new).getContent().document : val.new;
                                    val.old = byName.includes(val.old) && reqResult.getOperation(val.old).getContent() ? reqResult.getOperation(val.old).getContent().document : val.old;
                                })
                            return item
                        })
                        commit('SET_REPORT_DATA', content);
                        commit('LOADED_SUCCESS');
                        resolve()
                    })
                }));
            } else {
                resolve();
            }
        })
    },

    exportDataAsXLSX({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw('reports.activity.export')
                .action({ ...buildFilter(params), format: 'xlsx'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.xlsx')

                resolve();
            }));
        })
    },


};

export const mutations: MutationTree<ActivityReportState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, data) {
        state.activity = data.activity;
    },
};

const getters = {

};

export const STORE_KEY = '$_activity_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
